import React from "react";
import "./SalesList.scss";
import { Box, Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { dateSavedToDisplay, uomToDisplay } from "../../constants/vtrTrip";
import { useSelector } from "react-redux";
import { getPortDisplay } from "../../constants/Sales";

const SalesList = (props) => {
  const { port: portList = [], uomCodes = [] } = useSelector(
    (state) => state.validation.validations
  );
  return (
    <div className="SalesList" data-testid="SalesList">
      {props.trip.hasOwnProperty("sales") &&
        props.trip.sales.map(function (d, idx) {
          let display_date_sold = dateSavedToDisplay(d.date_sold);
          let port_display = getPortDisplay(d.offloading_port, portList);
          return (
            <div key={"sales_" + idx} className="margTop10">
              <Button
                style={{
                  width: "310px",
                  minWidth: "55vw",
                  maxWidth: "75vw",
                  backgroundColor: "lightgray",
                }}
              >
                <Link
                  style={{ width: "100%" }}
                  to={`${process.env.PUBLIC_URL}/sales-edit`}
                  state={{
                    trip_id: props.trip.trip_id,
                    client_id: props.client_id,
                    sales_id: idx,
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <h3
                        style={{
                          borderBottom: "solid 1px #3f51b5",
                          width: "100%",
                        }}
                      >
                        Sales: {idx + 1}
                      </h3>
                    </Grid>
                  </Grid>
                  <Box align="left">
                    <Grid container spacing={3}>
                      <Grid item xs={5}>
                        Species:
                      </Grid>
                      <Grid item xs={5}>
                        {d.species}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={5}>
                        Sold:
                      </Grid>
                      <Grid item xs={5}>
                        {d.sold + " " + uomToDisplay(d.uom, uomCodes)}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={5}>
                        Dealer:
                      </Grid>
                      <Grid item xs={5}>
                        {d.dealer_permit_number + " - " + d.dealer_name}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={5}>
                        Port:
                      </Grid>
                      <Grid item xs={5}>
                        {port_display ? port_display : ""}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={5}>
                        Date Sold:
                      </Grid>
                      <Grid item xs={5}>
                        {display_date_sold ? display_date_sold : ""}
                      </Grid>
                    </Grid>
                  </Box>
                </Link>
              </Button>
            </div>
          );
        })}
    </div>
  );
};
export default SalesList;
